<div class="header-wrapper">
  <div *ngIf="!!environment" class="strip" [ngClass]="environment">
    {{ moduleHeaderData?.environment }} {{ capitalizeFirstLetter(environment) }}
  </div>
  <div class="p-toolbar-group-center" *ngIf="!!activeTab && false">
    <div class="title">
      <span>{{activeTab['tabLabel']}}</span>
    </div>
  </div>
  <div class="header-container">
    <div class="logo-wrapper" (click)="logoClick()">
      <div class="logo-container" role="button"
        [attr.aria-label]="moduleHeaderData?.iaaLogoHomePage"
        (keydown.enter)="logoClick()" tabindex="0">
        <img [ngClass]="{'logo-en': moduleHeaderData?.isEnglish === true}" [src]="'./assets/logo-icon.svg'"
          alt="" />
      </div>
      <div class="title-container">
        <h1 class="title">{{ moduleHeaderData?.iaa | uppercase}}</h1>
        <!-- <h2 class="subtitle"> | {{ (moduleHeaderData?.iaa || 'רשות העתיקות') | uppercase}}</h2> -->
      </div>
    </div>
    <div class="tabs-container">
      <div class="tabs-menu">
        <div
          role="button"
          *ngFor="let item of tabMenuItems"
          class="tab-item"
          [ngClass]="{'active': activeTab.id === item.id}"
          tabindex="0"
          (click)="onTabClick(item)"
          (keydown.enter)="onTabClick(item)"
        >
          <img
            [ngClass]="{'icon-active': activeTab.id === item.id, 'icon-inactive': activeTab.id !== item.id}"
            [src]="activeTab.id === item.id ? item.icon : getInActiveIcon(item.id || '')"
            alt=""
          />
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="pages-container"
      [ngClass]="{'ltr': moduleHeaderData?.isEnglish === true, 'rtl': moduleHeaderData?.isEnglish === false}">
      <!-- <div role="tablist" aria-label="תפריט ראשי">
        <button class="tab-btn" *ngFor="let page of pages" tabindex="0" [attr.aria-selected]="activePage.id === page.id"
          [attr.aria-label]="page.text" [ngClass]="{'selected': activePage.id === page.id}"
          (click)="handlePageChange(page.id)" (keydown.enter)="handlePageChange(page.id)" role="tab">
          <img class="header-icon" height="24" width="24"
            [src]="activePage.id === page.id ? 'assets/' + page.name + '-icon-selected.svg' : 'assets/' + page.name + '-icon.svg'"
            [alt]="page.text" />
        </button>
      </div> -->
      <!-- <div class="seperator" *ngIf="pages.length > 0"></div> -->
      <button (click)="toggleInfoExpansionClick($event)" (keydown)="toggleInfoExpansion($event)" class="kebab-button"
        [attr.id]="'info-pages-menu-button'" [ngClass]="{'selected': isInfoExpanded}"
        [attr.aria-expanded]="isInfoExpanded" aria-controls="info-pages-menu" aria-haspopup="menu"
        [attr.aria-label]="isInfoExpanded ? moduleHeaderData?.closeInformationMenu : moduleHeaderData?.openInformationMenu"
        tabindex="0">
        <img width="24" height="24" src="assets/kebab.svg" [alt]="moduleHeaderData?.informationMenu" />
      </button>
      <nav id="info-pages-menu" *ngIf="isInfoExpanded" class="info-pages-container" role="navigation" [ngClass]="{
       'en': moduleHeaderData?.isEnglish,
       'he': (languageConfig | async)?.english && !moduleHeaderData?.isEnglish
     }" [attr.aria-label]="moduleHeaderData?.informationMenu">

        <button *ngFor="let page of infoPages" type="button" tabindex="0"
          [attr.role]="page.id == 6 ? 'button' : 'link'"
          [attr.aria-current]="activePage.id === page.id ? 'page' : null" [attr.aria-label]="page.ariaLabelText || page.text"
          [style.min-width]="moduleHeaderData?.isEnglish && page.id === 6 ? '150px' : '93px'"
          [ngClass]="{ 'selected': activePage.id === page.id }" (click)="handlePageChange(page.id)"
          (keydown.space)="handlePageChange(page.id)" (mouseenter)="setHoverExpansion(page.id)"
          (mouseleave)="setHoverExpansion(-1)" (focus)="setFocusExpansion(page.id)" (blur)="setFocusExpansion(-1)"
          (keydown.enter)="handlePageChange(page.id)">

          <img class="header-icon" height="24" width="24" [src]="(activePage.id === page.id && focusedMenuId === activePage.id)
                || hoveredMenuId === page.id
                || focusedMenuId === page.id
                ? 'assets/' + page.name + '-icon-selected.svg'
                : 'assets/' + page.name + '-icon.svg'" [alt]="page.text" />

          <div class="label">{{ page.text }}</div>
        </button>
      </nav>
      <button *ngIf="isAuthenticated" (click)="openTutorialVideo()"  class="contact-button" (mouseenter)="setHoverTutorialVideo(true)"
        (mouseleave)="setHoverTutorialVideo(false)" (focus)="setHoverTutorialVideo(true)" (blur)="setHoverTutorialVideo(false)"
        [attr.id]="'tutorial-video-button'"
        attr.aria-label="{{ moduleHeaderData?.tutorialVideos }} - {{ moduleHeaderData?.opensInNewTab }}"
        role="link"
        [pTooltip]="moduleHeaderData?.tutorialVideos">
        <img class="contact-icon" height="24" width="24"
          [src]="hoveredTutorialVideo ? 'assets/tutorial-video-selected.svg' : 'assets/tutorial-video.svg'" alt=""
          aria-hidden="true" />
      </button>
      <button  *ngIf="isAuthenticated" (click)="openModels()" class="contact-button" (mouseenter)="setHoverModels(true)"
        (mouseleave)="setHoverModels(false)" (focus)="setHoverModels(true)" (blur)="setHoverModels(false)"
        [attr.id]="'models-button'"
        attr.aria-label="{{ moduleHeaderData?.models }} - {{ moduleHeaderData?.opensInNewTab }}"
        role="link"
        [pTooltip]="moduleHeaderData?.models">
        <img class="contact-icon" height="24" width="24"
          [src]="hoveredModels ? 'assets/models-selected.svg' : 'assets/models.svg'" alt=""
          aria-hidden="true" />
      </button>
      <button *ngIf="isInternalUser" (click)="declined()" class="contact-button" (mouseenter)="setHoverDeclined(true)"
        (mouseleave)="setHoverDeclined(false)" (focus)="setHoverDeclined(true)" (blur)="setHoverDeclined(false)"
        [attr.id]="'declined-button'"
        attr.aria-label="{{ moduleHeaderData?.excludedLicenses }} - {{ moduleHeaderData?.opensInNewTab }}"
        role="link"
        [pTooltip]="moduleHeaderData?.excludedLicenses">
        <img class="contact-icon" height="24" width="24"
          [src]="hoveredDeclined ? 'assets/declined-selected.svg' : 'assets/declined.svg'" alt=""
          aria-hidden="true" />
      </button>

      <div *ngIf="moduleHeaderData && (languageConfig | async)?.english" 
      class="language-dropdown combobox-container" 
      [ngClass]="{'open': isDropdownOpen, 'canTranslate': moduleHeaderData && (languageConfig | async)?.english}">
   
   <div 
        role="combobox" 
        [attr.id]="'translate-button'"
        [attr.aria-expanded]="isDropdownOpen"
        [attr.aria-haspopup]="'listbox'"
        [attr.aria-controls]="'language-listbox'"
        [attr.aria-labelledby]="'language-label'"
        [attr.aria-activedescendant]="isDropdownOpen && currentLanguageIndex >= 0 ? 'language-option-' + (currentLanguageIndex === 0 ? 'he' : 'en') : null"
        class="language-trigger"
        [class.disabled]="moduleHeaderData.disabledLanguageButton"
        [class.open]="isDropdownOpen"
        (click)="!moduleHeaderData.disabledLanguageButton && toggleDropdown()"
        (keydown)="handleLanguageKeydown($event)"
        (mouseenter)="setHoverLanguage(true)"
        (mouseleave)="setHoverLanguage(false)"
        (focus)="setHoverLanguage(true)"
        (blur)="setHoverLanguage(false)"
        [pTooltip]="moduleHeaderData.changeLanguageTooltip"
        [tooltipDisabled]="moduleHeaderData.disabledLanguageButton"
        tabindex="0">
        
     <span id="language-label" class="sr-only">{{ moduleHeaderData.changeLanguage }}</span>
     
     <img [src]="hoveredLanguage ? './assets/globus-selected.svg' : './assets/globus.svg'"
          [alt]="moduleHeaderData.globeIcon"
          class="globe-icon"
          height="16" 
          width="16" />
     
     <span class="language-text">
       {{ moduleHeaderData.isEnglish ? moduleHeaderData.english : moduleHeaderData.hebrew }}
     </span>
     
     <svg class="dropdown-arrow" 
          [ngClass]="{'rotated': isDropdownOpen}"
          width="12" 
          height="12" 
          viewBox="0 0 12 12">
       <path d="M3 4.5L6 7.5L9 4.5" 
             stroke="currentColor" 
             stroke-width="1.5" 
             stroke-linecap="round" 
             stroke-linejoin="round" 
             fill="none"/>
     </svg>
   </div>
   
   <div 
        *ngIf="isDropdownOpen && !moduleHeaderData.disabledLanguageButton"
        [attr.id]="'language-listbox'"
        class="dropdown-menu"
        role="listbox"
        [attr.aria-labelledby]="'language-label'"
        tabindex="-1">
     <div 
          [attr.id]="'language-option-he'"
          role="option"
          [attr.aria-selected]="!moduleHeaderData.isEnglish"
          class="dropdown-item"
          [ngClass]="{'active': !moduleHeaderData.isEnglish, 'focused': currentLanguageIndex === 0}"
          (click)="selectLanguage('he')"
          tabindex="-1">
       <svg class="check-icon" *ngIf="!moduleHeaderData.isEnglish" width="16" height="16" viewBox="0 0 16 16">
         <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="currentColor"/>
       </svg>
       <span>{{ moduleHeaderData.hebrew }}</span>
     </div>
     <div 
          [attr.id]="'language-option-en'"
          role="option"
          [attr.aria-selected]="moduleHeaderData.isEnglish"
          class="dropdown-item"
          [ngClass]="{'active': moduleHeaderData.isEnglish, 'focused': currentLanguageIndex === 1}"
          (click)="selectLanguage('en')"
          tabindex="-1">
       <svg class="check-icon" *ngIf="moduleHeaderData.isEnglish" width="16" height="16" viewBox="0 0 16 16">
         <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="currentColor"/>
       </svg>
       <span>{{ moduleHeaderData.english }}</span>
     </div>
   </div>
 </div>
 

      <button (click)="contactUs()" class="contact-button" (mouseenter)="setHoverContact(true)"
        (mouseleave)="setHoverContact(false)" (focus)="setHoverContact(true)" (blur)="setHoverContact(false)"
        [attr.id]="'contact-us-button'" attr.aria-label="{{ moduleHeaderData?.contactUs }} - {{ moduleHeaderData?.opensInNewTab }}" role="link"
        [pTooltip]="moduleHeaderData?.contactUs">
        <img class="contact-icon" height="24" width="24"
          [src]="hoveredContact ? 'assets/contact-icon-selected.svg' : 'assets/contact-icon.svg'" alt=""
          aria-hidden="true" />
      </button>
      <!-- <span id="tooltip-contact" class="sr-only">{{ moduleHeaderData?.clickToContact || 'לחץ ליצירת קשר'}}</span> -->
      <!-- <div *ngIf="hoveredContact" id="tooltip-contact" role="tooltip" class="tooltip">
        {{ moduleHeaderData?.contactUs || 'צור קשר' }}
      </div> -->
      <!-- </div> -->
      <div class="auth-container">
        <ng-container *ngIf="isAuthenticated;">
          <div class="user-menu-container combobox-container">
            <div 
                 role="combobox"
                 [attr.id]="'user-menu-button'"
                 [attr.aria-expanded]="isUserMenuOpen"
                 [attr.aria-haspopup]="'listbox'"
                 [attr.aria-controls]="'user-menu-listbox'"
                 [attr.aria-labelledby]="'user-menu-label'"
                 [attr.aria-activedescendant]="isUserMenuOpen && currentUserMenuIndex >= 0 ? 'user-menu-option-' + currentUserMenuIndex : null"
                 class="user-menu-trigger"
                 [class.open]="isUserMenuOpen"
                 (click)="toggleUserMenu()"
                 (keydown)="handleUserMenuKeydown($event)"
                 (mouseenter)="setHoverUser(true)"
                 (mouseleave)="setHoverUser(false)"
                 (focus)="setHoverUser(true)"
                 (blur)="setHoverUser(false)"
                 tabindex="0">
              
              <span id="user-menu-label" class="sr-only">{{ moduleHeaderData?.userMenu }}</span>
              
              <img class="user-icon" 
                   [ngClass]="{'en': moduleHeaderData?.isEnglish === true}" 
                   [src]="hoveredUser 
                     ? (isInternalUser ? './assets/internal-user-selected.svg' : './assets/external-user-selected.svg')
                     : (isInternalUser ? './assets/internal-user.svg' : './assets/external-user.svg')" 
                   [alt]="moduleHeaderData?.userIcon" />
              
              <span class="user-text">
                {{ moduleHeaderData?.hello }} {{ userName }}
              </span>
            </div>
            
            <div 
                 *ngIf="isUserMenuOpen"
                 [attr.id]="'user-menu-listbox'"
                 class="user-menu-dropdown"
                 role="listbox"
                 [attr.aria-labelledby]="'user-menu-label'"
                 tabindex="-1">
              <div 
                   *ngFor="let item of (userMenuItemsUnified || userMenuItems); let i = index"
                   [attr.id]="'user-menu-option-' + i"
                   role="option"
                   [attr.aria-selected]="i === currentUserMenuIndex"
                   class="user-menu-item"
                   [ngClass]="{'active': i === currentUserMenuIndex}"
                   (click)="item.command && item.command(); closeUserMenu()"
                   tabindex="-1">
                <span class="menu-item-label">{{ item.label }}</span>
                <span [class]="item.icon" [ngStyle]="item.iconStyle"></span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="navigation-container"  *ngIf="isAuthenticated;">
        <!-- <p-button [tabindex]="0" styleClass="btn-nav" [rounded]="true" [text]="true" (click)="goNext()"
        (keydown.enter)="goNext()" [ariaLabel]="'לעמוד הבא'">
        <svg xmlns="http://www.w3.org/2000/svg" width="9.57" height="16.583" viewBox="0 0 9.57 16.583"
          transform="scale(-1, 1)">
          <path id="Path_149" data-name="Path 149"
            d="M123.744,151.472c.746.779,4.449,4.409,5.942,5.895a1.273,1.273,0,0,1,.359,1.339,1.193,1.193,0,0,1-1,.86,1.318,1.318,0,0,1-1.212-.461q-2.293-2.3-4.594-4.6-1.086-1.086-2.172-2.171a1.3,1.3,0,0,1,0-2.082q3.343-3.347,6.688-6.692a1.468,1.468,0,0,1,1.147-.558,1.266,1.266,0,0,1,.837,2.157c-.716.731-1.443,1.452-2.167,2.175-.791.791-3.125,2.953-4.081,3.862"
            transform="translate(-120.544 -143.003)" fill="#a88349" />
        </svg>
      </p-button> -->
        <p-button [tabindex]="0" styleClass="btn-nav" [rounded]="true" [text]="true" (click)="goBack()"
          (keydown.enter)="goBack()" [ariaLabel]="moduleHeaderData?.toThePreviousPage"
          [pTooltip]="moduleHeaderData?.toThePreviousPage">
          <svg xmlns="http://www.w3.org/2000/svg" width="9.57" height="16.583" viewBox="0 0 9.57 16.583"
            [ngStyle]="{ transform: moduleHeaderData?.isEnglish ===true ? 'scale(-1, 1)' : 'none' }">
            <path id="Path_149" data-name="Path 149"
              d="M123.744,151.472c.746.779,4.449,4.409,5.942,5.895a1.273,1.273,0,0,1,.359,1.339,1.193,1.193,0,0,1-1,.86,1.318,1.318,0,0,1-1.212-.461q-2.293-2.3-4.594-4.6-1.086-1.086-2.172-2.171a1.3,1.3,0,0,1,0-2.082q3.343-3.347,6.688-6.692a1.468,1.468,0,0,1,1.147-.558,1.266,1.266,0,0,1,.837,2.157c-.716.731-1.443,1.452-2.167,2.175-.791.791-3.125,2.953-4.081,3.862"
              transform="translate(-120.544 -143.003)" fill="#a88349" />
          </svg>
        </p-button>
      </div>
    </div>
  </div>

  <!-- <div *ngIf="isVideoModalOpen" class="video-modal-overlay" (click)="closeVideoModal()" 
        role="dialog" aria-modal="true">
    <div class="video-modal-content" (click)="$event.stopPropagation()">
      <button class="video-modal-close" (click)="closeVideoModal()" 
              type="button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <video class="video-player" controls autoplay >
        <source [src]="videoUrl" type="video/mp4">
         הדפדפן שלך אינו תומך בתג הווידאו.
      </video>
    </div>
  </div> -->
</div>